import { isEmpty } from 'lodash';

const checkEmptyObject = <Type>(obj: Type) => (!isEmpty(obj) ? obj : null);

export default checkEmptyObject;
